import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  countries,
  getCountryDataFromIsoCode,
  getCountryNames,
  getCountryDataFromName,
} from '../../utils/countryUtils';
import { useStyles } from './style';

interface Props {
  id: string;
  label: string;
  value: string;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  onChange: (country: string) => void;
  onBlur?: () => void;
}

export function CountrySelect(props: Props) {
  const countrySelectStyles = useStyles();

  function handleInputChange(value: string) {
    const country = getCountryDataFromName(value);
    if (country && country.iso) props.onChange(country.iso);
  }

  return (
    <Autocomplete
      id={props.id}
      className={countrySelectStyles.label}
      options={getCountryNames(countries)}
      value={getCountryDataFromIsoCode(props.value)?.label || ''}
      onInputChange={(ev, val) => handleInputChange(val)}
      onBlur={props.onBlur}
      
      autoHighlight
      renderInput={params => (
        <TextField
          {...params}
          label={props.label}
          variant='outlined'
          fullWidth
          required={props.required}
          error={props.error}
          helperText={props.helperText}
          onBlur={props.onBlur}
        />
      )}
    />
  );
}
